import { render } from "./Tag.vue?vue&type=template&id=34ced0bc"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"
script.render = render

export default script